<template>
  <div class="gene-mutaion">
    <div class="cards-title">
      <span>{{ headName }}</span>

      <span @click="cancerSpecies"
        >{{ headView }}<i class="iconfont icon-right_small titleView"></i
      ></span>
    </div>
    <div class="cards-shaw"></div>
    <Empty v-if="tableData.length <= 0" />
    <div v-else class="gene-mutaion-list">
      <div
        class="genne-mutaion-head"
        v-for="item in titleData"
        :key="item.name"
      >
        <span>{{ item.name }}</span>
        <span>{{ item.samplenum }}</span>
        <span class="nomal">{{ item.percentage }}</span>
      </div>

      <div
        class="genne-mutaion-content"
        v-for="item in tableData"
        :key="item.name"
      >
        <span @click="handleClick1(item)" :style="{ color: color1 }">{{
          item.name
        }}</span>
        <span @click="handleClick2(item)" :style="{ color: color2 }">{{
          item.samplenum
        }}</span>
        <span>{{ item.percentage }}</span>
      </div>
      <div
        class="mutaion-tab-box"
        v-if="flag == true"
        @click="ceiliingAnalysis"
      >
        <div class="mutaion-tab">
          <span>点突变/拷贝数/基因重排分析</span>
          <i class="iconfont icon-right_small geneView"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    headName: String,
    headView: String,
    titleData: null,
    tableData: null,
    flag: Boolean,
    color1: String,
    color2: String,
  },
  data() {
    return {
      type: "1",
    };
  },
  methods: {
    handleClick1(item) {
      let param = {
        name: "wdJiedu",
        type: "0",
        gene: item.name,
        proteinChange: "",
        tabIndex: "2",
        fromSource: "sv",
      };
      this.$emit("geneClick", param);
      let cancer = {
        name: "cancer",
        params: item.name,
      };
      this.$emit("cancerName", cancer);
    },
    handleClick2(item) {
      let param = {
        type: "hzList",
        gene: item.name,
        fromSource: "sv",
      };
      // 人群基因突变频率
      this.$emit("clickYangben", param);
      // 癌种
      this.$emit("aiYangben", {
        cancer: item.name,
        type: "hzList",
        fromSource: "cancer",
      });
      // 产品类型样本数点击
      this.$emit("cpYangben", {
        Class: item.name,
        type: "hzList",
        fromSource: "product",
      });
    },
    cancerSpecies() {
      // 人群基因突变查看全部点击
      this.$emit("cancerSpecies", { type: "8000", fromSource: "sv" });
      // 癌肿查看全部点击
      this.$emit("ai", { type: "8002", fromSource: "cancer" });
      this.$emit("geneAi", { type: "8002" });
      // 产品类型查看全部点击
      this.$emit("cpCalss", { type: "8003", fromSource: "product" });
    },

    ceiliingAnalysis() {
      this.$emit("ceiliingAnalysis", { type: "8001", fromSource: "sv" });
    },
  },
};
</script>
<style scoped lang="less">
.cards-title {
  height: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.titleView {
  line-height: 70px;
  margin-right: 25px;
  color: #4b84ff;
  font-size: 12px;
}
.geneView {
  float: right;
  line-height: 36px;
  margin-right: 13px;
  color: #4b84ff;
  font-size: 12px;
}
.cards-title > span:nth-of-type(1) {
  display: inline-block;
  font-size: 18px;
  font-family: @family;
  font-weight: 500;
  color: #2f354d;
  padding-left: 24px;
  line-height: 70px;
}

.cards-title > span:nth-of-type(2) {
  font-size: 12px;
  font-family: @family;
  font-weight: 400;
  color: #4b84ff;
  float: right;
  margin-right: 3px;
  line-height: 70px;
}

.cards-shaw {
  display: inline-block;
  width: 343px;
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(52, 68, 132, 0) 0%,
    rgba(52, 68, 132, 0.1) 100%
  );
}

.gene-mutaion {
  width: 343px;
  height: auto;
  background: @background_color;

  border-radius: 10px;
  margin: 0 auto;
  margin-top: 20px;
}
.gene-mutaion-list {
  padding-bottom: 16px;
}
.genne-mutaion-head {
  height: 48px;
  background: @background_color;
  padding-left: 24px;
  padding-right: 24px;
}

.genne-mutaion-head > span {
  float: left;
  height: 48px;
  line-height: 48px;
  font-size: 15PX;
  font-family: @family;
  font-weight: 500;
  color: #9095a7;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.genne-mutaion-head > span:nth-of-type(1) {
  width: 45%;
}

.genne-mutaion-head > span:nth-of-type(2) {
  width: 30%;
  margin-left: 5%;
}

.genne-mutaion-head > span:nth-of-type(3) {
  width: 20%;
}

.genne-mutaion-content {
  height: 48px;
  padding-left: 24px;
  padding-right: 24px;
  // .active{
  //   color: #27CA8D !important;
  // }
}

.genne-mutaion-content > span {
  float: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 48px;
}

.genne-mutaion-content > span:nth-of-type(1) {
  float: left;
  font-size: 15PX;
  font-family: @family;
  font-weight: 500;
  color: #4b84ff;
  width: 45%;
}

.genne-mutaion-content > span:nth-of-type(2) {
  font-size: 15PX;
  font-family: @family;
  font-weight: 400;
  color: #2f354d;
  width: 30%;
  margin-left: 5%;
}

.genne-mutaion-content > span:nth-of-type(3) {
  font-size: 15PX;
  font-family: @family;
  font-weight: 400;
  color: #2f354d;
  width: 20%;
}

.mutaion-tab-box {
  margin-top: 10px;
  padding-left: 24px;
  padding-right: 24px;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
}

.mutaion-tab {
  padding-left: 16px;
  height: 36px;
  background: #e4ecff;
  border-radius: 6px;
  width: 100%;
  box-sizing: border-box;
}

.mutaion-tab > span:nth-of-type(1) {
  font-size: 12px;
  font-family: @family;
  font-weight: 400;
  color: #4b84ff;
  line-height: 36px;
}

.mutaion-tab > span:nth-of-type(2) {
  font-size: 12px;
  font-family: @family;
  font-weight: 400;
  color: #4b84ff;
  line-height: 36px;
  float: right;
  margin-right: 13px;
}
</style>
